import UserTokenCallback from '../schema/UserTokenCallback';

let userTokenCallback: UserTokenCallback | undefined;

export function setUserTokenCallback(callback?: UserTokenCallback) {
    userTokenCallback = callback;
}

//To do: GetAccessTokenForResource method should return token value with auth scheme.
// Until then consumer opx scenario requests need to be addressed on case by case basis.
export async function getUserToken(): Promise<string | undefined> {
    const token = userTokenCallback && (await userTokenCallback());

    if (token && token.length > 0) {
        if (token?.split(' ')[0]?.toLowerCase() === 'bearer') {
            return token.split(' ')[1]; // drop bearer prefix and just return the token value for JWT tokens
        } else if (token?.split(' ')[0]?.toLowerCase() === 'msauth1.0') {
            return token; // return the token value with auth scheme for MSA tokens
        }
    }
    return undefined;
}
